import React from 'react';

const EmptyState = (props) => {

    const boxStyle = {
        width: "100%",
        height: "200px",
        border: "4px dashed #CCC",
        display: "flex",
        marginBottom: "8px"
    }
    
    return (
        <div className="text-center" style={boxStyle}>
            <div style={{margin: "auto"}}>
                <h5>{props.message}</h5>
            </div>
        </div>);
}
export default EmptyState;